import { FILTER_TYPE, MAIN_CATEGORIES_ID } from './constants';

import { type Navigation } from '@/types/api/product';

export const getCategoryChips = (filters: Navigation['filters'] = []) => {
  const types = filters.find(filter => filter.internalName.includes(FILTER_TYPE));
  const mainCategories = filters.find(filter => filter.internalName === MAIN_CATEGORIES_ID);

  return mainCategories && mainCategories.refinements.length > 1 ? mainCategories : types;
};
